export const authConfig = {
    domain: "fyps-24.us.auth0.com",
    clientId: "hCukgqkUQFskIlQDTxragN6o9u8sCGxN",
    //redirectUri: "http://localhost:3001/",
    redirectUri: "https://fyps.aamirakbar.com/marks",
    audience: "fyps-auth",
    //returnto: "http://localhost:3001"
    returnto: "https://fyps.aamirakbar.com"
};
  